// extracted by mini-css-extract-plugin
module.exports = {"reportWrapper":"ReportModal_reportWrapper__37OYE"};